export const parseCareersPage = (pageData) => {
  const header = {
    ruleLabel: pageData.eyebrow,
    subheading: pageData.description.childMarkdownRemark.html,
    noJobs: pageData.noJobs.childMarkdownRemark.html,
  };

  const careers = pageData.careers
    ? pageData.careers.map((career) => {
        return {
          id: career.id,
          title: career.title,
          description: career.description.childMarkdownRemark.html,
          link: career.link,
        };
      })
    : [];

  return {
    header,
    careers,
  };
};
